import React from 'react'

function TodayAppointment() {
  return (
    <div>TodayAppointment</div>
  )
}

export default TodayAppointment